import { request, requestWithMeta } from './client.js'

export const DEVICE_TYPES = [
  'NODE_EDGE',
  'TABLET_PENGUJI',
  'PAPAN_ROTASI',
  'PERANGKAT_PS',
  'ROUTER',
  'UPS',
] as const
export type DeviceType = (typeof DEVICE_TYPES)[number]

export const DEVICE_STATUSES = [
  'DISIAPKAN',
  'DIKIRIM',
  'TERPASANG',
  'CADANGAN',
  'RUSAK',
  'RMA',
  'DINONAKTIFKAN',
] as const
export type DeviceStatus = (typeof DEVICE_STATUSES)[number]

export interface Device {
  readonly id: string
  readonly serialNumber: string
  readonly type: DeviceType
  readonly model: string | null
  readonly status: DeviceStatus
  readonly tukId: string | null
  readonly signingKeyFingerprint: string | null
  readonly enrolledAt: string | null
  readonly tuk: { readonly code: string; readonly name: string } | null
}

export interface DeviceDetail extends Device {
  readonly allowedNext?: readonly DeviceStatus[]
}

export interface Movement {
  readonly id: string
  readonly fromTukId: string | null
  readonly toTukId: string | null
  readonly reason: string
  readonly movedBy: string
  readonly movedAt: string
}

export interface SummaryRow {
  readonly type: DeviceType
  readonly status: DeviceStatus
  readonly count: number
}

export async function listDevices(
  page: number,
  q: string,
  filters: { status?: string; type?: string } = {},
): Promise<{ rows: readonly Device[]; total: number }> {
  const params = new URLSearchParams({ page: String(page), limit: '25' })
  if (q !== '') params.set('q', q)
  if (filters.status !== undefined && filters.status !== '') params.set('status', filters.status)
  if (filters.type !== undefined && filters.type !== '') params.set('type', filters.type)
  const { data, total } = await requestWithMeta<readonly Device[]>(`/api/v1/perangkat?${params}`)
  return { rows: data, total }
}

export async function summary(): Promise<readonly SummaryRow[]> {
  return request<readonly SummaryRow[]>('/api/v1/perangkat/ringkasan')
}

export async function detail(id: string): Promise<DeviceDetail> {
  return request<DeviceDetail>(`/api/v1/perangkat/${id}`)
}

export async function history(id: string): Promise<readonly Movement[]> {
  return request<readonly Movement[]>(`/api/v1/perangkat/${id}/riwayat`)
}

export async function register(input: {
  serialNumber: string
  type: DeviceType
  model?: string
}): Promise<Device> {
  return request<Device>('/api/v1/perangkat', { method: 'POST', body: input })
}

export async function changeStatus(
  id: string,
  input: { status: DeviceStatus; reason: string; tukId?: string },
): Promise<DeviceDetail> {
  return request<DeviceDetail>(`/api/v1/perangkat/${id}/status`, { method: 'POST', body: input })
}
